import { Sort } from '@angular/material/sort';
import { IFetchEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/fetch-entity-failure-payload.interface';
import { IModuleCompletionSection } from '../interfaces/module-completion-section.interface';
import { UserSectionStats } from '../models/user-section.model';

export class SetUserSectionStats {
    static readonly type = '[UserSectionStats] SetUserSectionStats';

    constructor(public payload: UserSectionStats[]) {}
}

export class AddUserSectionStats {
    static readonly type = '[UserSectionStats] AddUserSectionStats';

    constructor(public payload: UserSectionStats[]) {}
}

export class UnsetUserSectionStats {
    static readonly type = '[UserSectionStats] UnsetUserSectionStats';
}

export class AddUserSectionStatsForParticipant {
    static readonly type = '[UserSectionStats] AddUserSectionStatsForParticipant';

    constructor(public payload: UserSectionStats[]) {}
}

export class FetchUserSectionStats {
    static readonly type = '[UserSectionStats] FetchUserSectionStats';

    constructor(
        public payload: {
            moduleId: string;
            pageSize?: number;
            pageNumber?: number;
            sortBy?: string;
            sortOrder?: string;
            search?: string;
            status?: string;
            sectionId?: string;
        }
    ) {}
}

export class FetchUserSectionStatsSuccess {
    static readonly type = '[UserSectionStats] FetchUserSectionStatsSuccess';

    constructor(public payload: UserSectionStats) {}
}

export class FetchUserSectionStatsFailure {
    static readonly type = '[UserSectionStats] FetchUserSectionStatsFailure';

    constructor(public payload: IFetchEntityFailureActionPayload) {}
}

export class UnsetUserSectionStatsForParticipant {
    static readonly type = '[UserSectionStats] UnsetUserSectionStatsForParticipant';
}

export class FetchUserSectionStatsForParticipant {
    static readonly type = '[UserSectionStats] FetchUserSectionStatsForParticipant';

    constructor(
        public payload: {
            moduleId: string;
            participantId: string;
        }
    ) {}
}

export class FetchUserSectionStatsForParticipantSuccess {
    static readonly type = '[UserSectionStats] FetchUserSectionStatsForParticipantSuccess';
}

export class FetchUserSectionStatsForParticipantFailure {
    static readonly type = '[UserSectionStats] FetchUserSectionStatsForParticipantFailure';
}

export class SectionCompletionForParticipant {
    static readonly type = '[UserSectionStats] SectionCompletionForParticipant';

    constructor(
        public payload: {
            sections: IModuleCompletionSection[];
            userId: number;
        }
    ) {}
}

export class SectionCompletionForParticipantSuccess {
    static readonly type = '[UserSectionStats] SectionCompletionForParticipantSuccess';
}

export class SectionCompletionForParticipantFailure {
    static readonly type = '[UserSectionStats] SectionCompletionForParticipantFailure';
}

export class SearchUserSectionStats {
    static readonly type = '[UserSectionStats] SearchUserSectionStats';

    constructor(public payload: string) {}
}

export class SortUserSectionStats {
    static readonly type = '[UserSectionStats] SortUserSectionStats';

    constructor(public payload: Sort) {}
}
